// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"zO","quote":"zP","quoteAuthor":"zQ"};